import React, { useState, useEffect } from "react";
import Slider from "react-slick";

import ArticleDetails from "./ArticleDetails";
import Section from "../../../components/Section";
import DialogBox from "../../../components/DialogBox";
import Background from "../../../components/Background";
import Feedback from "../../../components/DialogBox/Feedback";
import ShareDialog from "../../../components/DialogBox/ShareDialog";

import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

import style from "./style.module.css";

export default function PhotoGallery(props) {
    const {
        id,
        gallery_images = [],
        autoplay = false,
        delay = 0,
    } = props;

    const [popup, setPopup] = useState(false);
    const [fullScreen, setFullScreen] = useState(false);
    const [mainSlider, setMainSlider] = useState(null);
    const [thumbSlider, setThumbSlider] = useState(null);

    const mainSliderSettings = {
        autoplay,
        autoplaySpeed: delay,
        arrows: true,
        fade: true,
        asNavFor: thumbSlider,
        centerMode: true,
        slidesToShow: 1,
        centerPadding: "0",
        speed: 500,
        focusOnSelect: true,
    };

    const thumbSliderSettings = {
        asNavFor: mainSlider,
        variableWidth: true,
        slidesToScroll: 1,
        centerMode: true,
        centerPadding: '0',
        focusOnSelect: true,
        infinite: true,
        speed: 500,
        arrows: false,
        dots: false,
        slideToClickedSlide: true,
    };

    useEffect(() => {
        if (mainSlider && thumbSlider) {
            mainSlider.slickGoTo(0);
        }
    }, [mainSlider, thumbSlider]);

    return (
        <>
            <Section id="documentViewer" className={`${style.photoGallery} ${fullScreen ? ` ${style.fullScreen}` : ''}`}>
                {
                    gallery_images.length > 0 && (
                        <div className={style.photoGalleryWrap}>
                            <Slider
                                {...mainSliderSettings}
                                className={style.photoGallerySlider}
                                ref={(slider) => setMainSlider(slider)}
                            >
                                {
                                    gallery_images.map((item, index) => (
                                        <div key={`photoGalleryItem_${index}`} className={style.photoGalleryItem}>
                                            <Background src={item} size="2560x1440" />
                                            <ArticleDetails 
                                                {...props} 
                                                setPopup={setPopup}
                                                fullScreen={fullScreen}
                                                setFullScreen={setFullScreen}
                                            />
                                        </div>
                                    ))
                                }
                            </Slider>
                            <div className={style.centerHelper}>
                                <Slider
                                    {...thumbSliderSettings}
                                    className={style.photoGallerySliderThumb}
                                    ref={(slider) => setThumbSlider(slider)}
                                >
                                    {
                                        gallery_images.map((item, index) => (
                                            <div key={`photoGalleryThumbItem_${index}`} className={style.photoGalleryThumbItem}>
                                                <Background src={item} size="2560x1440" />
                                            </div>
                                        ))
                                    }
                                </Slider>
                            </div>
                        </div>
                    )
                }
            </Section>
            {
                popup === "share" && (
                    <ShareDialog onClose={() => { setPopup(false) }} />
                )
            }
            {
                popup === "feedback" && (
                    <DialogBox
                        onClose={() => setPopup(false)}
                        className={`${style.articlePopup}`}
                        title={false}
                        headerClass={style.dialogBoxHeader}
                        modalClassName={style.articleModal}
                        buttonClassName={style.customCloseStyle}
                        hasCloseIcon={false}
                        render={({ closeDialog }) => {
                            return (
                                <Feedback id={id} closeDialog={closeDialog} type="feedback" />
                            )
                        }}
                    />
                )
            }
        </>
    );
}
